import { useState } from "react"
import BaseDocumentCreator from "../../../../components/documents/baseDocumentCreator"
import styles from '../styles/importRemainContent.module.scss'
import { useAppContext } from "../../../../system/providers/appContextProvider"
import { useTabsContext } from "../../../../system/providers/tabsProvider"
import { LgWidthMarketContractContent } from "../components/LgWidthMarketContractContent"
import { marketContractRequest } from "../request/marketContractRequest"
import { MessageModalWindow } from "../../../../components/modalWindows/MessageModalWindow"

export interface IValidator {
    reportId: string
    certificateId: string
}

export interface IFileWrapper {
    file: IFile[]
    id: string | null
}
interface IMessageModalProps {
    show: boolean,
    message: string,
    handler?: () => void
}

export const ImportMarketingContractContent = (props) => {
    const tabContext = useTabsContext()
    const admissibleExtension: string = 'csv';

    const [file, setFile] = useState<IFileWrapper>({ file: [], id: null });
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [showMessageModal, setShowMessageModal] = useState<IMessageModalProps>({ show: false, message: '' });

    return (
        <BaseDocumentCreator
            cancel={{

                title: 'Закрыть',
                onClick: () => { tabContext.closeCurrent() }
            }}
        >
            <div className={styles.layout}>
                {
                    <LgWidthMarketContractContent
                        file={file}
                        setFile={setFile}
                        admissibleExtension={admissibleExtension}
                        importFile={() => {
                            marketContractRequest({idFileGlobal: file.id as string}, setIsSubmitting).then((result) => {
                                if (result) {
                                    setFile({file: [], id: null })
                                    setShowMessageModal({message: 'Маркетинговый контракт успешно импортирован', show: true})
                                }
                            })
                        }}
                        isSubmitting={isSubmitting}
                        setSubmitting={setIsSubmitting}                        
                    />
                }
            </div>
            {
                showMessageModal.show &&
                <MessageModalWindow 
                    message={showMessageModal.message}
                    ok={{
                        onClick() {setShowMessageModal({message:"", show: false})},
                        title:'Продолжить'
                    }}
                   
                    cancel={{onClick() {setShowMessageModal({message:"", show: false})},hidden:true}}
                />
            }
        </BaseDocumentCreator >
    )
}